import EmptyResult from "common/components/EmptyResult/EmptyResult";
import TooltipWrapper from "common/components/TooltipWrapper/TooltipWrapper";
import Icon, { IconNames } from "components/Icon/Icon";
import { useTranslation } from "react-i18next";

type BadgeProps = {
  name: string;
  subtitle?: string;
};

type Props = {
  items: BadgeProps[];
  short?: boolean;
  className?: string;
  iconName?: IconNames;
  vertical?: boolean;
};

function Badges({
  items,
  short = false,
  className,
  iconName,
  vertical = false,
}: Props) {
  const { t } = useTranslation();
  if (!items?.length) {
    return <EmptyResult text={t("forms.noContactGroup")} />;
  }

  const list = items?.map(({ name, subtitle }) => {
    const node = () => (
      <span className="flex gap-1 h-6 items-center border border-primary-700 rounded-lg py-1 px-2 text-xs">
        <Icon name={iconName ?? "UsersIcon"} className="w-4 h-4" />
        <span>{name}</span>

        {!short && subtitle && (
          <span className="text-xs text-slate-400 italic"> - {subtitle}</span>
        )}
      </span>
    );

    return short && subtitle ? (
      <TooltipWrapper
        key={name}
        className="mr-1 my-1"
        content={<span>{subtitle}</span>}
      >
        {node()}
      </TooltipWrapper>
    ) : (
      <div key={name} className="mr-1 my-1">
        {node()}
      </div>
    );
  });
  return (
    <div
      className={`flex gap-1 flex-wrap ${short ? "flex-wrap" : ""} ${
        vertical ? "flex-col items-start" : "flex-row items-center"
      } ${className}`}
    >
      {list}
    </div>
  );
}

export default Badges;
